<button 
  [type]="type"
  [disabled]="disabled"
  [class]="buttonClasses"
  (click)="onButtonClick($event)">
  
  <daz-icon 
    *ngIf="icon && iconPosition === 'left'" 
    [name]="icon" 
    [size]="iconSize" 
    [color]="iconColor">
  </daz-icon>
  
  <span *ngIf="text" class="button-text">{{ text }}</span>
  
  <daz-icon 
    *ngIf="icon && iconPosition === 'right'" 
    [name]="icon" 
    [size]="iconSize" 
    [color]="iconColor">
  </daz-icon>
</button>